// extracted by mini-css-extract-plugin
export var announcer = "Gallery-module--announcer--cd485";
export var btnNext = "Gallery-module--btnNext--494de";
export var btnPrev = "Gallery-module--btnPrev--9823e";
export var buttons = "Gallery-module--buttons--6a421";
export var count = "Gallery-module--count--0b58e";
export var inner = "Gallery-module--inner--4746f";
export var isHero = "Gallery-module--isHero--2fa82";